/**
 * Splide
 */

import Splide from '@splidejs/splide';

// MV
export function kvSplide() {
  document.addEventListener( 'DOMContentLoaded', function() {

    var splideElement = document.querySelector('.p-mv > .splide');

    if (splideElement) {
      var splide = new Splide( '.p-mv > .splide', {
        autoplay    : true,
        type        : "loop",
        focus       : 'center',
        arrows      : false,
        pauseOnHover: false,
        pauseOnFocus: true,
        interval    : 6000,
        speed       : 600,
        gap         : '16px',
        perPage     : 1,
        padding     : 0,
        drag        : true,
        mediaQuery  : 'min',
        // classes: {
        //   pagination: 'splide__pagination your-class-pagination',
        //   page      : 'splide__pagination__page your-class-page',
        // },
        breakpoints : {
          600: {
            drag: true,
          }
        }
      } );
      splide.mount();
    }
  });

}
